import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { IoClose } from 'react-icons/io5';
import warningGif from '../../assets/gifs/warning.gif';

const AlertVerificationPopup = ({ isOpen, toggle }) => {
  return (
    <Modal size="lg" show={isOpen} onHide={toggle} centered>
      <Modal.Body
        className="p-2 cursor-pointer"
        style={{
          backgroundColor: '#fff',
          borderRadius: '15px',
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
        }}
      >
        <div className="text-center position-relative">
          {/* Close Button */}
          <IoClose
            className="text-danger position-absolute"
            style={{ top: '10px', right: '10px', fontSize: '30px', cursor: 'pointer' }}
            onClick={toggle}
          />
          {/* Warning Image */}
          <img
            src={warningGif}
            alt="Warning Animation"
            width="140"
            style={{ maxWidth: '100%', height: 'auto', marginBottom: '20px' }} 
          />

          <h3 className="fw-bold text-danger mb-3">ALERT</h3>
          <div className="px-4 mx-auto">
            <p className="text-dark fs-5 fw-semibold mb-3">
              Please note that AECCI will not be verifying the Directorate General of Foreign Trade (DGFT) issued Certificate of Origin (Non-Preferential).
            </p>
            <p className="text-dark fs-5 fw-semibold mb-3">
              AECCI will only be verifying shipping documents that are relevant to the eCOO (NP) issued through the DGFT portal.
            </p>
            <p className="text-secondary fs-6">
              For any inconvenience, feel free to contact our chamber helpdesk. <strong>022-41271145/46</strong>.
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AlertVerificationPopup;
